import React from 'react';
import ReactDOM from "react-dom";
import IntNumberFormatInput from './int_number_input_formatter';
import PropTypes from 'prop-types';

export default class IntCellEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
    };

    getValue() {
        return { [this.props.column.key]: this.state.value }
    };

    getInputNode() {
        return ReactDOM.findDOMNode(this).getElementsByTagName("input")[0];
    };

    handleChangeComplete = value => {
        this.props.onCommit();
    }

    handleChange = event => {
        this.setState({ value: event.target.value });
    }

    render() {
        return (

            <div style={{ textAlign: 'right' }}>
                <IntNumberFormatInput
                    value={this.state.value}
                    onChange={this.handleChange}
                    onBlur={(event) => this.handleChangeComplete(event.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') { e.preventDefault(); this.handleChangeComplete(e.target.value) };
                    }}
                    style={{ textAlign: 'right' }} />
            </div>

        );

    };

};

IntCellEditor.propTypes = {
    column: PropTypes.object,
};
